module.exports = __webpack_public_path__ + "static/media/twitter.881ca3f1.svg";